const team = {
  "team-management.invite.error": "Ocurrió un error al intentar eliminar la invitación. Por favor intenta de nuevo o contacta al soporte.",
  "team-management.players.list.header": "Jugadores ({{ players }})",
  "team-management.amount.players": "{{ players }} jugadores",
  "team-management.players.list.item.header.you": "{{ name }} (tú)",
  "team-management.players.list.item.subheader": "Entrenó hace {{ timeAgo }}",
  "team-management.players.list.item.subheader.alt": "Sin actividad aún",
  "team-management.invites.list.header": "Invitaciones",
  "team-management.invites.list.item.sent": "Enviado hace {{ timeAgo }}",
  "team-management.invites.list.item.declined": "Rechazada",
  "team-management.invite-button": "Invitar jugadores ({{ invitesLeft }} restantes)",
  "team-management.no-team": "No tienes un equipo para administrar.",
  "team-management.no-team.action": "Configurar equipo",
  "team-management.no-permission": "Un equipo te está otorgando acceso, por lo que no puedes crear ni administrar uno propio.",
  "team-management.invite.drawer.title": "Invitar miembros del equipo",
  "team-management.invite.drawer.submit": "Invitar",
};

const player = {
  "team-management.player.info.league": "Liga {{ league }}, División {{ division }}",
  "team-management.player.info.age": "{{ age }} años",
  "team-management.player.remove": "Eliminar",
  "team-management.player.remove.confirm.title": "¿Eliminar jugador?",
  "team-management.player.remove.confirm.body": "¿Estás seguro de que deseas eliminar a este jugador de tu equipo?",
  "team-management.player.view-progress": "Ver progreso",
  "team-management.player.skill-radar.title": "Radar de habilidades",
  "team-management.player.stats.title": "Estadísticas ({{ dateRange }})",
  "team-management.player.stats.filter": "Cambiar rango de fechas",
  "team-management.player.progress-chart.placeholder": "Sin datos de entrenamiento para el período seleccionado",
  "team-management.player.metric-results.placeholder": "Sin datos de entrenamiento para el período seleccionado",
  "team-management.player.metric-results.title": "Resultados por métrica",
  "team-management.player.activity-card.title": "Actividad",
  "team-management.player.training-card.title": "Entrenamiento",
  "team-management.player.training-card.label": "Sesiones",
};

export const teamManagement = { ...player, ...team };
